import { render, staticRenderFns } from "./Rejected.vue?vue&type=template&id=3c9f42c9&lang=true&"
import script from "./Rejected.vue?vue&type=script&lang=js&"
export * from "./Rejected.vue?vue&type=script&lang=js&"
import style0 from "./Rejected.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports